<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">

<div class="flex align-items-center">
  <i *ngIf="$.row && $.adata.fetch_key && $.row[$.adata.fetch_key]=='success'" class="fa fa-circle text-green-500 mr-2"></i>
  <i *ngIf="$.row && $.adata.fetch_key && $.row[$.adata.fetch_key]=='failed'" class="fa fa-circle p-error mr-2"></i>
   <span class="uppercase">{{ $.row[$.adata.fetch_key] }}</span>
</div>
</ng-container>
